// CU-86d45b2z1 — implemented customer destinations only; sibling tasks add theirs here, never as placeholder or disabled entries.
import type { ComponentType } from "react";
import { HistoryOutlined, ShoppingOutlined } from "@ant-design/icons";

export interface CustomerDestination {
	key: string;
	path: string;
	label: string;
	icon: ComponentType;
}

export const CUSTOMER_PRODUCTS_PATH = "/customer/products";
export const CUSTOMER_ORDERS_PATH = "/customer/orders";
// CU-14ygtkj8nr3: Profile is reached from the sidebar footer menu, not the middle navigation.
export const CUSTOMER_PROFILE_PATH = "/customer/profile";

export const CUSTOMER_DESTINATIONS: readonly CustomerDestination[] = [
	{ key: "products", path: CUSTOMER_PRODUCTS_PATH, label: "Products", icon: ShoppingOutlined },
	// CU-86d45b2zn: order history, deliberately not a cart icon — no cart or checkout exists yet.
	{ key: "orders", path: CUSTOMER_ORDERS_PATH, label: "Orders", icon: HistoryOutlined },
];
